// import  axios  from 'axios';
import { Axios } from '../plugins/axios.js'

const state = {
}

const getters = {

}

const mutations = {

}

const actions = {
  getHalls ({ commit }, { params }) {
    return new Axios()
      .get('biav/v1/admin/hall', {
        params
      })
      .then(response => {
        return response
      })
      .catch(() => {
        return 'error'
      })
  },
  getTableData ({ commit, state }, payload) {
    const data = payload.data
    let page = data.page
    let url = ''

    page += -1
    data.page = page

    for (const content in data) {
      url += `&${content}=${data[content]}`
    }

    return new Axios()
      .get(`/biav/v1/admin/hall?${url}`, data)
      .then(response => {
        return response
      })
      .catch(() => {
        return 'error'
      })
  },

  getProvinceAndCity ({ commit, state }, payload) {
    return new Axios()
      .get('location/v1/province?include_city=1')
      .then(response => {
        return response
      })
      .catch(() => {
        return 'error'
      })
  },

  getEnums ({ commit, state }, payload) {
    return new Axios()
      .get('biav/v1/admin/enum_set')
      .then(response => {
        return response
      })
      .catch(() => {
        return 'error'
      })
  },

  editEntryHall ({ commit, state }, payload) {
    const data = payload.data
    const formData = new FormData()
    let valueAppend = ''

    const facilities = data.facilities
    const using_type = data.using_type
    const ball_type = data.ball_type

    for (const key in data) {
      valueAppend = data[key]

      if (Array.isArray(data[key])) {
        const covertStringifyJson = JSON.stringify(valueAppend)
        formData.append(key, covertStringifyJson)
      } else {
        formData.append(key, valueAppend)
      }
    }

    // request send new data //
    if (typeof (data.id) === 'undefined') {
      return new Axios()
        .post('biav/v1/admin/team/store', formData)
        .then(response => {
          return response
        })
        .catch(() => {
          return 'error'
        })
    } else {
      // edit data //
      return new Axios()
        .post('biav/v1/admin/hall/update', formData)
        .then(response => {
          return response
        })
        .catch(() => {
          return 'error'
        })
    }
  }

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
